import { Controller } from "@hotwired/stimulus"

// Persona Memories page: reveals a memory row's inline edit form when its pencil
// is tapped (each card owns its own [data-memories-target="edit"] form, hidden
// by default in CSS via the .is-editing class on the card).
export default class extends Controller {
    static targets = ["card", "edit"]

    toggleEdit(event) {
        const card = event.target.closest("[data-memories-target='card']")
        if (!card) return
        card.classList.toggle("is-editing")
        if (card.classList.contains("is-editing")) {
            const input = card.querySelector(".memory-edit-input")
            if (input) {
                input.focus()
                input.setSelectionRange(input.value.length, input.value.length)
            }
        }
    }
}
